import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';

interface Props {
	data: any[];
	title: string;
	dataKey: string;
	grid?: boolean;
}

const Chart = ({ data, title, dataKey, grid }: Props) => {
	return (
		<>
			<h3 className='text-2xl font-semibold mb-3 ml-5'>{title}</h3>
			<div className="w-full h-52 md:h-64">
				<ResponsiveContainer>
					<LineChart
						data={data}
						margin={{
							top: 5,
							right: 30,
							left: 20,
							bottom: 5,
						}}
					>
						{grid && <CartesianGrid strokeDasharray='5 5' />}
						<XAxis dataKey={'name'} stroke='#5550bd' />
						<YAxis />
						<Tooltip />
						<Legend />
						<Line
							type='monotone'
							dataKey={dataKey}
							stroke='#8884d8'
							activeDot={{ r: 8 }}
						/>
					</LineChart>
				</ResponsiveContainer>
			</div>
		</>
	);
};

export default Chart;
